module.exports = __webpack_public_path__ + "img/shop-by-style-lincoln.4c331477.png";